module.exports = __webpack_public_path__ + "static/media/9-6.bf5e0501.mp3";